import {api} from "./api";

export const loadMore = (path) => {
    const loader = document.getElementById('loading')
    const pageContainer = document.getElementById('load_more')
    const page = parseInt(pageContainer.dataset.page)
    const lastPage = parseInt(pageContainer.dataset.last)
    const current_url = pageContainer.dataset.url
    
    // Check if we've reached the last page before making the request
    if (page > lastPage) {
        pageContainer.remove()
        return
    }
    
    loader.classList.remove('hidden')
    
    // Get current URL parameters and update page
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete('search')
    urlSearchParams.delete('route')
    urlSearchParams.set('page', page.toString())
    
    // Build the URL with all parameters
    const queryString = urlSearchParams.toString()
    api.get(`${path}&${queryString}&url=${encodeURIComponent(current_url)}`)
        .then(async (response) => {
            const text = await response.text();
            
            // Check if we got any content back
            if (!text || text.trim() === '') {
                loader.classList.add('hidden')
                pageContainer.remove()
                return
            }
            
            let article = document.getElementsByTagName('article')
            setTimeout(() => {
                article[0].insertAdjacentHTML('beforeend', text)
                loader.classList.add('hidden')
                
                // Update URL to reflect the page we just loaded
                const url = new URL(window.location.href)
                url.searchParams.set('page', page.toString())
                window.history.pushState({path: url.href}, '', url.href)
            }, 300)
            
            // Update page number for next request
            const nextPage = page + 1
            if (nextPage <= lastPage) {
                pageContainer.setAttribute('data-page', nextPage.toString())
            } else {
                pageContainer.remove()
            }
        })
        .catch((error) => {
            loader.classList.add('hidden')
            console.error('Error loading more products:', error)
        })
}